import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import { RpcOutbound } from '../rpc-outbound';
import {
    RpcObservableExtensionDataError, RpcObservableExtensionDataKey, RpcObservableExtensionDataRequest, RpcObservableExtensionDataResult
} from './rpc-observable-extension-data-model';

export class RpcObservableExtensionDataClient
    extends RpcObservableClient<RpcObservableExtensionDataRequest, RpcObservableExtensionDataResult, RpcObservableExtensionDataError>  {

    /**
     * Initializes a new instance of the RpcObservableExtensionDataClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableExtensionDataKey.command, RpcObservableExtensionDataKey.version);
    }

    /**
     * The storeData command.
     *
     * @param request the Rpc extension data object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableExtensionDataResult> the observable object.
     */
    public storeData(request?: RpcObservableExtensionDataRequest, outbound?: RpcOutbound): Observable<RpcObservableExtensionDataResult> {
        return this.observableCall(request, outbound);
    }

    /**
     * The retrieveData command.
     *
     * @param request the Rpc extension data object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableExtensionDataResult> the observable object.
     */
    public retrieveData(request?: RpcObservableExtensionDataRequest, outbound?: RpcOutbound): Observable<RpcObservableExtensionDataResult> {
        return this.observableCall(request, outbound);
    }
}
